import { createFileRoute } from '@tanstack/react-router'
import SubscribersAndTokens from 'Administration/components/system/webhooks/SubscribersAndTokens'

export const Route = createFileRoute('/administration/integrations/_webhooks/webhook/subscribers')({
    component: SubscribersAndTokens,
})
